import "../../css/Home.css";
import React, { Suspense } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../Component/Navbar.js";
import SEO from "../../Component/Layout.js";

// image
import backgroundProjectCustomEngine from "../../img/backgroundCustomEngine.webp";
import backgroundCPPBibliotheque from "../../img/backgroundCPPBibliotheque.webp";
import backgroundProjectLUA from "../../img/backgroundLUA.webp";

// Traduction
import { Loader } from "../../Component/ComponentTraduction.js";
import { withTranslation } from "react-i18next";

import FocusLoop from "../../Component/FocusLoop.js";

const JVPageT = ({ t }) => {
  const { lang = "fr" } = useParams();
  return (
    <>
      <SEO
        lang={lang}
        path="/ProjectsVideosGames"
        title={`${t("VideoGamesProjects.Title")} - Arthur BRU`}
        description="Projets jeu vidéo d'Arthur BRU en C++, C# et LUA : moteur custom, bibliothèques, Tower Defense, Platformer 2D. Réalisés en équipe ou en solo."
        ogTitle="Projets Jeu Vidéo - Arthur BRU"
        ogDescription="Projets jeu vidéo en C++, C# et LUA : moteur custom, bibliothèques, Tower Defense, Platformer 2D."
        structuredData={`{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "name": "Projets Jeu Vidéo - Arthur BRU",
              "url": "https://www.arthur-portfolio.dev/ProjectsVideosGames",
              "description": "Projets jeu vidéo en C++, C# et LUA : moteur custom, bibliothèques, Tower Defense, Platformer 2D.",
              "author": { "@type": "Person", "name": "Arthur BRU" }
            },
            { "@type": "SoftwareApplication", "name": "Angine", "description": "Moteur de jeu vidéo custom développé en C++.", "author": { "@type": "Person", "name": "Arthur BRU" }, "applicationCategory": "DeveloperApplication", "url": "https://github.com/PoloBongo/custom-engine-cpp" },
            { "@type": "VideoGame", "name": "Helluva Revenge", "author": { "@type": "Person", "name": "Arthur BRU" }, "gamePlatform": "PC", "applicationCategory": "Game", "url": "https://github.com/DemonXlegenD/Helluva-Revenge" },
            { "@type": "VideoGame", "name": "Tower Defense", "author": { "@type": "Person", "name": "Arthur BRU" }, "gamePlatform": "PC", "applicationCategory": "Game" },
            { "@type": "SoftwareApplication", "name": "C++ Bibliothèque", "description": "Bibliothèques C++ développées en équipe.", "author": { "@type": "Person", "name": "Arthur BRU" }, "applicationCategory": "DeveloperApplication" },
            { "@type": "VideoGame", "name": "Tour par tour en console", "author": { "@type": "Person", "name": "Arthur BRU" }, "gamePlatform": "PC", "applicationCategory": "Game" },
            { "@type": "VideoGame", "name": "Shoot-Em-Up", "author": { "@type": "Person", "name": "Arthur BRU" }, "gamePlatform": "PC", "applicationCategory": "Game" },
            { "@type": "SoftwareApplication", "name": "Projets LUA", "description": "Projets développés en LUA.", "author": { "@type": "Person", "name": "Arthur BRU" }, "applicationCategory": "DeveloperApplication" }
          ]
        }`}
      />
    <div className="Home-header overflowHidden fontsRegular">
      <FocusLoop>
        <Navbar tabIndex={9} />
        <div className="traitSeparator" id="blur"></div>
        <div>
          <div className="contactMeFlex align-items-center fixBackBtnUnity">
            <h1 className="fontsBold underline titleUnityPage" id="blur">
              {t("VideoGamesProjects.Title")}
            </h1>
          </div>
          <div className="grid-gamejam2">
            <div
              className="marge-contact-play modernEnvelop flex-column-center"
              id="blur"
            >
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Angine</h3>
              </div>
              <div className="flexIMG width">
                <img
                  src={backgroundProjectCustomEngine}
                  alt="Custom Engine"
                  className="sizeProjectIMG2"
                  loading="lazy"
                />
              </div>
              <div className="grid-gamejam">
                <p className="text-align-left padding-1vw font-size-large">
                  <p>
                    <span className="colorPurple">
                      {t("VideoGamesProjects.Langage")}
                    </span>{" "}
                    {t("VideoGamesProjects.Angine.Langage")}
                  </p>
                  <p>
                    <span className="colorPurple">
                      {t("VideoGamesProjects.ToolsUsed")}
                    </span>
                  </p>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: t("VideoGamesProjects.Angine.ToolsUsed"),
                    }}
                  ></p>
                  <p>
                    <span className="colorPurple">
                      {t("VideoGamesProjects.Duration")}
                    </span>{" "}
                    {t("VideoGamesProjects.Angine.Duration")}
                  </p>
                  <p>
                    <span className="colorPurple">
                      {t("VideoGamesProjects.Completion")}
                    </span>{" "}
                    {t("VideoGamesProjects.Angine.Completion")}
                  </p>
                  <p>
                    <span className="colorPurple">
                      {t("VideoGamesProjects.TeamSize")}
                    </span>{" "}
                    {t("VideoGamesProjects.Angine.TeamSize")}
                  </p>
                  <p>
                    <span className="colorPurple">
                      {t("VideoGamesProjects.Role")}
                    </span>{" "}
                    {t("VideoGamesProjects.Angine.Role")}
                  </p>
                </p>
                <p className="text-align-left padding-1vw font-size-large">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: t("VideoGamesProjects.Angine.Description"),
                    }}
                  ></p>
                </p>
              </div>
              <div className="btnDiscoverProject">
                <a
                  href="https://github.com/PoloBongo/custom-engine-cpp"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={1}
                  style={{
                    display: "block",
                    opacity: "1",
                    overflow: "hidden",
                    transition: "all 1s ease",
                  }}
                >
                  <button className="btnStyleDiscoverProject fontsBold z-index responsive-text-btn">
                    {t("VideoGamesProjects.viewMoreCode")}
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className="grid-gamejam">
            <div
              className="marge-contact-play modernEnvelop flex-column-center"
              id="blur"
            >
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Helluva Revenge</h3>
              </div>
              <div className="flexIMG width">
                <iframe
                  src="https://www.youtube.com/embed/xkXIosIVZRE"
                  title="youtubeVideoPresentation"
                  frameBorder="0"
                  width="560"
                  height="315"
                  allowFullScreen
                  className="iframeYoutube"
                ></iframe>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("VideoGamesProjects.helluvaRevenge"),
                  }}
                ></p>
              </p>
              <div className="btnDiscoverProject">
                <a
                  href="https://github.com/DemonXlegenD/Helluva-Revenge"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={2}
                  style={{
                    display: "block",
                    opacity: "1",
                    overflow: "hidden",
                    transition: "all 1s ease",
                  }}
                >
                  <button className="btnStyleDiscoverProject fontsBold z-index responsive-text-btn">
                    {t("VideoGamesProjects.viewMoreCode")}
                  </button>
                </a>
              </div>
            </div>
            <div
              className="marge-contact-play modernEnvelop flex-column-center"
              id="blur"
            >
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Tower Defense</h3>
              </div>
              <div className="flexIMG width">
                <iframe
                  src="https://www.youtube.com/embed/33BohK7tIfQ"
                  title="youtubeVideoPresentation"
                  frameBorder="0"
                  width="560"
                  height="315"
                  allowFullScreen
                  className="iframeYoutube"
                ></iframe>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("VideoGamesProjects.towerDefense"),
                  }}
                ></p>
              </p>
              <div className="btnDiscoverProject">
                <a
                  href="https://github.com/PoloBongo/CPP_Tower_Defense"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={3}
                  style={{
                    display: "block",
                    opacity: "1",
                    overflow: "hidden",
                    transition: "all 1s ease",
                  }}
                >
                  <button className="btnStyleDiscoverProject fontsBold z-index responsive-text-btn">
                    {t("VideoGamesProjects.viewMoreCode")}
                  </button>
                </a>
              </div>
            </div>
            <div
              className="marge-contact-play modernEnvelop flex-column-center"
              id="blur"
            >
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">C++ Bibliothèque</h3>
              </div>
              <div className="flexIMG width">
                <img
                  src={backgroundCPPBibliotheque}
                  loading="lazy"
                  alt="Bibliothèque Cpp"
                  className="sizeProjectIMG"
                ></img>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("VideoGamesProjects.bibliotheque"),
                  }}
                ></p>
              </p>
              <div className="btnDiscoverProject">
                <a
                  href="https://github.com/PoloBongo/CPP_Bibliotheque/"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={4}
                  style={{
                    display: "block",
                    opacity: "1",
                    overflow: "hidden",
                    transition: "all 1s ease",
                  }}
                >
                  <button className="btnStyleDiscoverProject fontsBold z-index responsive-text-btn">
                    {t("VideoGamesProjects.viewMoreCode")}
                  </button>
                </a>
              </div>
            </div>
            <div
              className="marge-contact-play modernEnvelop flex-column-center"
              id="blur"
            >
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Tour par tour en console</h3>
              </div>
              <div className="flexIMG width">
                <iframe
                  src="https://www.youtube.com/embed/QB-EAMeCPpQ"
                  title="youtubeVideoPresentation"
                  frameBorder="0"
                  width="560"
                  height="315"
                  allowFullScreen
                  className="iframeYoutube"
                ></iframe>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("VideoGamesProjects.CSharpConsole"),
                  }}
                ></p>
              </p>
              <div className="btnDiscoverProject">
                <a
                  href="https://github.com/PoloBongo/Projet9---CSharp"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={5}
                  style={{
                    display: "block",
                    opacity: "1",
                    overflow: "hidden",
                    transition: "all 1s ease",
                  }}
                >
                  <button className="btnStyleDiscoverProject fontsBold z-index responsive-text-btn">
                    {t("VideoGamesProjects.viewMoreCode")}
                  </button>
                </a>
              </div>
            </div>
            <div
              className="marge-contact-play modernEnvelop flex-column-center"
              id="blur"
            >
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Shoot-Em-Up</h3>
              </div>
              <div className="flexIMG width">
                <iframe
                  src="https://www.youtube.com/embed/r-x6qlMXgxo"
                  title="youtubeVideoPresentation"
                  frameBorder="0"
                  width="560"
                  height="315"
                  allowFullScreen
                  className="iframeYoutube"
                ></iframe>
              </div>
              <p className="text-align-left padding-1vw font-size-large">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("VideoGamesProjects.shootEmUp"),
                  }}
                ></p>
              </p>
              <div className="btnDiscoverProject">
                <a
                  href="https://github.com/PoloBongo/Shoot-Em-Up"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={6}
                  style={{
                    display: "block",
                    opacity: "1",
                    overflow: "hidden",
                    transition: "all 1s ease",
                  }}
                >
                  <button className="btnStyleDiscoverProject fontsBold z-index responsive-text-btn">
                    {t("VideoGamesProjects.viewMoreCode")}
                  </button>
                </a>
              </div>
            </div>
            <div
              className="marge-contact-play modernEnvelop flex-column-center"
              id="blur"
            >
              <div className="sizeIconCPlus flexIMG">
                <h3 className="Home width">Projets LUA</h3>
              </div>
              <div className="flexIMG width">
                <img
                  src={backgroundProjectLUA}
                  loading="lazy"
                  alt="Shoot-Em-Up Thème Futuriste"
                  className="sizeProjectIMG"
                ></img>
              </div>
              <p className="text-align-left padding-1vw font-size-large pDescription fontsLight">
                {t("VideoGamesProjects.luaPart1")}
                <a
                  href="https://www.youtube.com/@Polo_Leaks"
                  className="link-navbar fontsRegular underline bold"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={7}
                >
                  Polo Leaks
                </a>
                {t("VideoGamesProjects.luaPart2")}
              </p>
              <div className="btnDiscoverProject">
                <a
                  href="https://github.com/PoloBongo/ExampleScriptsLua"
                  target="_blank"
                  rel="noreferrer"
                  tabIndex={8}
                  style={{
                    display: "block",
                    opacity: "1",
                    overflow: "hidden",
                    transition: "all 1s ease",
                  }}
                >
                  <button className="btnStyleDiscoverProject fontsBold z-index responsive-text-btn">
                    {t("VideoGamesProjects.viewMoreCode")}
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </FocusLoop>
    </div>
    </>
  );
};

const TranslatedHome = withTranslation()(JVPageT);

export default function JVPage() {
  return (
    <Suspense fallback={<Loader />}>
      <TranslatedHome />
    </Suspense>
  );
}
